<template>
  <div class="w-full p-5 md:w-128 pt-16 sm:pt-5" data-testid="viewer-share-modal">
    <Tabs :selected-tab="selectedTab || '#access-settings'">
      <div class="mt-4">
        <Tab id="access-settings" name="Email or link"><AccessSettings :expireButtonHighlighter="expireButtonHighlighter" /></Tab>
        <Tab id="social-media" name="Social media"><SocialMedia /></Tab>
        <Tab id="embed" data-testid="viewer-share-modal-tab-embed" name="Embed" v-if="embeddingAllowed && !isMobile"><EmbedShare /></Tab>
        <Tab v-if="description" id="export" data-testid="viewer-share-modal-tab-export" name="Export"><Export /></Tab>
      </div>
    </Tabs>
  </div>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { Tabs, Tab } from '@/storybook/tabs';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

import AccessSettings from '@/modules/viewer/components/share/AccessSettings.vue';
import SocialMedia from '@/modules/viewer/components/share/SocialMedia.vue';
import EmbedShare from '@/modules/viewer/components/share/EmbedShare.vue';
import Export from '@/modules/viewer/components/share/Export.vue';
import { useMobileDetection } from '@/composables/useMobileDetection';

defineProps<{
  selectedTab?: string;
  expireButtonHighlighter?: boolean;
}>();

const viewerItemStore = useViewerItemStore();
const { embeddingAllowed } = storeToRefs(viewerItemStore);
const { isMobile } = useMobileDetection(true);
const itemStore = useViewerItemStore();
const { description } = storeToRefs(itemStore);
</script>
